import {
  HttpInterceptorFn,
  HttpErrorResponse
} from '@angular/common/http';

import { inject } from '@angular/core';
import { Router } from '@angular/router';

import {
  catchError,
  throwError
} from 'rxjs';

import { AuthService } from '../services/auth.service';


const PUBLIC_AUTH_URLS = [

  '/auth/p/login',

  '/auth/p/register',

  '/auth/p/forgot-password',

  '/auth/reset-password'

];


export const authInterceptor: HttpInterceptorFn = (
  req,
  next
) => {

  const router = inject(Router);

  const authService = inject(AuthService);


  // =====================================================
  // CHECK PUBLIC API
  // =====================================================

  const isPublicAuth =
    PUBLIC_AUTH_URLS.some(url =>
      req.url
        .toLowerCase()
        .includes(url.toLowerCase())
    );


  let clonedRequest = req;


  // =====================================================
  // JWT
  // =====================================================

  const token =
    localStorage.getItem('token');


  // Only attach JWT to protected APIs
  if (!isPublicAuth && token) {

    clonedRequest =
      clonedRequest.clone({

        setHeaders: {
          Authorization: `Bearer ${token}`
        }

      });

  }


  // =====================================================
  // CONTENT TYPE
  // =====================================================

  // Don't set Content-Type manually for FormData
  if (!(clonedRequest.body instanceof FormData)) {

    clonedRequest =
      clonedRequest.clone({

        setHeaders: {
          'Content-Type': 'application/json'
        }

      });

  }


  // =====================================================
  // REQUEST
  // =====================================================

  return next(clonedRequest).pipe(

    catchError(
      (error: HttpErrorResponse) => {

        // Only redirect protected APIs to login
        if (
          (error.status === 401 ||
            error.status === 403) &&
          !isPublicAuth
        ) {

          authService.logout();

          router.navigate(['/login']);

        }

        return throwError(
          () => error
        );

      }
    )

  );

};
